import { createRoot } from 'react-dom/client';
import { createElement } from 'react';

export default function checkoutSurveyLauncher() {
    return import(
        /* webpackChunkName: "checkoutSurvey" */
        '../../../abandonedCheckout/components/CheckoutSurvey'
    ).then(({ default: CheckoutSurvey }) => {
        const el = window.document.createElement('div');
        window.document.body.appendChild(el);
        const root = createRoot(el);
        root.render(createElement(CheckoutSurvey, {}));
    });
}
